<template>
    <div class="profile-search">
        <div class="search-fields">
            <div class="field">
                <ui5-label for="profile-number">Profielnummer:</ui5-label>
                <ui5-input
                    type="Text"
                    :disabled="disabled || search.searching"
                    id="profile-number"
                    @change="onSearchProfile"
                    @keyup.enter="onSearchProfile"
                    :value="search.code"
                    @input="search.code = $event.target.value"
                    placeholder="Profielnummer"
                >
                    <i
                        slot="icon"
                        class="fa fa-search"
                    />
                </ui5-input>
            </div>
            <div class="field">
                <ui5-label for="profile-name">Naam:</ui5-label>
                <ui5-input
                    type="Text"
                    :disabled="disabled || search.searching"
                    id="profile-name"
                    @change="onSearchProfile"
                    @keyup.enter="onSearchProfile"
                    :value="search.name"
                    @input="search.name = $event.target.value"
                    placeholder="Naam"
                >
                    <i
                        slot="icon"
                        class="fa fa-search"
                    />
                </ui5-input>
            </div>
        </div>
        <spinner-text v-if="search.searching">
            Zoekt naar profielen...
        </spinner-text>
        <ul
            id="profilelist"
            v-if="profiles"
        >
            <li
                v-for="profile in profiles"
                :key="'profile.' + profile.profileId"
            >
                <a
                    @click="
                        profileSelected(profile);
                        profiles = null;
                    "
                    :id="profile.profileId"
                >
                    {{ profile.code }}, {{ profile.description }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import profileApi from '../../api/profile';
import SpinnerText from '../../components/loader/SpinnerText';
import { showErrorMessage } from '../../dialogs';

export default {
    components: { SpinnerText },
    props: ['disabled', 'profileSelected'],
    data() {
        return {
            profiles: null,
            search: {
                searching: false,
                code: '',
                name: '',
            },
        };
    },
    methods: {
        onSearchProfile() {
            if (this.search.code.length >= 2 || this.search.name.length >= 2) {
                this.search.searching = true;
                profileApi
                    .list(this.search.code, this.search.name)
                    .then((response) => {
                        this.profiles = response.data.data;
                    })
                    .catch(() => {
                        showErrorMessage('Fout bij zoeken naar profielen');
                    })
                    .finally(() => {
                        this.search.searching = false;
                    });
            }
        },
    },
};
</script>
